import { useEffect, useState, useCallback } from 'react';
import { fetchPrcPrice, fetchPrcFee } from '../api/transactions';

const REFRESH_MS = 60_000;

function PriceFeePill({ className = '' }) {
  const [price, setPrice] = useState(null);
  const [fee, setFee] = useState(null);

  const load = useCallback(async () => {
    try {
      const [priceRes, feeRes] = await Promise.all([fetchPrcPrice(), fetchPrcFee()]);
      if (priceRes?.success) setPrice(priceRes.data);
      if (feeRes?.success) setFee(feeRes.data);
    } catch {
      /* silent */
    }
  }, []);

  useEffect(() => {
    load();
    const id = setInterval(load, REFRESH_MS);
    return () => clearInterval(id);
  }, [load]);

  const priceDisplay = price?.price_usdt != null
    ? `$${Number(price.price_usdt).toFixed(2)}`
    : '—';

  const pairLabel = price?.pair || 'PRC/USDT';

  const feeDisplay = fee?.network_fee
    ? `${fee.network_fee.percent}%`
    : fee?.fee_percent != null
      ? `${fee.fee_percent}%`
      : '—';

  const rootClass = ['price-fee-pill', className].filter(Boolean).join(' ');

  return (
    <div className={rootClass} role="group" aria-label="PRC token price and swap fee">
      <div className="price-fee-pill__left">
        <img
          src="/images/chains/prc.png"
          alt="PRC"
          className="price-fee-pill__coin-img"
        />
        <span className="price-fee-pill__price">{priceDisplay}</span>
        <span className="price-fee-pill__pair">{pairLabel}</span>
      </div>
      <span className="price-fee-pill__sep" aria-hidden>|</span>
      <div className="price-fee-pill__right">
        <span className="price-fee-pill__label">Swap Fee:</span>
        <span className="price-fee-pill__fee">
          {feeDisplay} <span className="price-fee-pill__fee-unit">PRC</span>
        </span>
      </div>
    </div>
  );
}

export default PriceFeePill;
